import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";
let checkingNative = new Object();

const getDefaultState = () => {
  return {
    checkGetSetNative: false,
    smphMchtlUniqNo: "", // 스마트폰 기기 고유번호
    pgmVsnno: "", // 프로그램 버전 번호, OS버전
    smphMdelName: "", // 스마트폰모델명
    pushToken: "", // 푸쉬토큰
    smphMchtlDstcd: "", // 스마트폰기기구분코드(1:IPhone, 2:android)
    appVersionName: "", // App 버전명
    appVersionCode: "", //App 버전코드
    biometryTypeIos: "", // Ios 지원바이오인증(faceId/touchId/none)
    biometryTypeAndroid: "", // Android 지원바이오인증(touchId/none)
    initSiteCode: "", // 최초기동시 native에 저장된 siteCode를 전달받음
    initNatCode: "", // 최초기동시 native에 저장된 natCode를 전달받음
    ocrInfo: {},
    permissionChk: "",
    popupShow: false,
    eKYCData: {}, // eKYC 정보 (추후 삭제)
    scanSelfieDataMatch: "", //생체검증 성공 여부
    depositEkyc: false, //계좌개설 EKYC 여부
  };
};

const native = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getNativeAll: state => {
      return state;
    },
    getFingerText: state => {
      return state.biometryTypeIos === "faceId" ? "FaceID" : "지문";
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    mut001: function (state, payload) {
      switch (payload.key) {
        case "siteCode":
          this.dispatch("actSiteCode", payload.value);
          break;
        case "natCode":
          this.state.natCode = payload.value;
          break;
        case "noticePopup":
          this.state.noticePopup = payload.value;
          break;
        case "mOtpPopup":
          this.state.mOtpPopup = payload.value;
          break;
        case "natUserAcnNtcClos":
          this.state.accounts.myAccounts.natUserAcnNtcClos = payload.value;
          break;
      }
    },
    mut002: function (state, payload) {
      this._vm.$set(state, payload.key, payload.value);
    },
    mut003: function (state, payload) {
      state.ocrInfo = payload;
    },
    goBackPage: function () {
      const route = router.app.$route;

      if ("login|createFidoPincodeGuide".includes(route.name)) {
        //로그인 메뉴 - 앱종료 팝업 닫기
        this.state.appExitModalOpended = !this.state.appExitModalOpended;
      } else if ("changePasswordForgottenStep1|userCipher3TmErrReqForgetStep1".includes(route.name)) {
        //비로그인 비밀번호 변경 메뉴 - 비밀번호 변경 3개 선택화면
        router.push({ name: "changePasswordParent" });
      } else if ((route.meta.goback !== undefined && route.meta.goback === false) || this.getters.isUserPwdRegiYn == "1" || this.getters.isUserPwdRegiYn == "2") {
        //상단 back버튼 hide || 비밀번호 강제 체크 계정일 때 - back버튼 무시
        return;
      } else if (route.name === "trsaccInfoInptReqGrpUpdat") {
        //당행이체(이체그룹수정) - 입금계좌선택으로 이동
        router.push({ name: "trsaccInfoInptStep2", params: { mgtSerno: this.state.transfer.trsaccInfoInpt.trsaccGrpInfo.mgtSerno } });
      } else if (route.name === "autoTrsaccUpdateReq1") {
        //자동이체변경 step1 - 자동이체등록/내역조회로 이동
        router.push({ name: "autoTrsaccRegiHist" });
      } else if (route.name === "manageAccountsRegister") {
        //출금계좌등록시
        router.push({ name: "manageAccountsList", params: { entrance: route.params.entrance } });
      } else if (route.name === "managePayeesRegister") {
        //자주쓰는계좌등록시
        router.push({ name: "managePayeesList", params: { currentTab: route.params.currentTab } });
      } else if (route.name === "managePayeesObRegister") {
        //자주쓰는계좌등록시
        router.push({ name: "managePayeesList", params: { currentTab: route.params.currentTab } });
      } else if (route.name === "pushNotiStup") {
        //알림설정 시
        router.push({ name: "noticeService", params: { currentTab: route.params.currentTab } });
      } else if (route.name == "newsDetail" && route.query.goBackPage == "main") {
        router.push({ name: "main", params: { siteCode: this.state.siteCode, lang: this.state.lang } });
      } else if (route.name == "electricityPaymentReqStep1" || route.name == "waterPaymentReqStep1") {
        router.push({ name: "billPaymentMain" });
      } else if (route.name == "cddEddForVtn") {
        router.push({ name: "inputPersonalInfo" });
      } else if (route.name == "manageAccountsList" && this.state.sessionInfo.userInfo.connAcitmDstic == "1A") {
        router.push({ name: "joinServiceAcnoInfoVtn" });
      } else if (route.name == "joinServiceAcnoInfoVtn" && this.state.sessionInfo.userInfo.connAcitmDstic == "1A") {
        router.push({ name: "serviceJoinStep3" });
      } else if (
        route.name == "ekycLogin" &&
        this.state.sessionInfo.userInfo.ppsnCoprDstcd === "1" &&
        this.state.sessionInfo.userInfo.mchtlModfiYn == "1" &&
        this.state.sessionInfo.userInfo.lvbdInfoRegiYn === "1"
      ) {
        router.push({ name: "ekycLogin" });
      } else if (route.name == "mmQrPaymentStep1") {
        this._vm.$bridge.qrScanForTransfer(this.state.common.main.operGroupCd);
        router.push({ name: "main", params: { siteCode: this.siteCode, lang: this.lang } });
      } else {
        // qrscan으로 들어와서 myQR or 결제내역으로 간 경우
        if (route.params.type == "qrscan") {
          this._vm.$bridge.qrScanForTransfer(this.state.common.main.operGroupCd);
        }
        // QR Scan을 통해서 결제내역 or myQR로 넘어온 경우는 다시 브릿지통신으로
        else {
          if (this.state.menuOpen) {
            //메뉴 닫기
            this.state.menuOpen = false;
          } else if (this.state.popupOpen) {
            //팝업 닫기
            this._vm.$EventBus.$emit("popupClose");
          } else {
            if (route.matched.length == 1) {
              if (route.name == "main") {
                let main = findSearchBox(router.app.$root.$children);
                if (main.page == "2") {
                  main.page = "1";
                } else {
                  //앱종료 팝업 닫기
                  this.state.appExitModalOpended = !this.state.appExitModalOpended;
                }
              } else {
                //앱종료 팝업 닫기
                this.state.appExitModalOpended = !this.state.appExitModalOpended;
              }

              return true;
            } else if (route.matched.length == 2) {
              //2depth 메뉴 -> 메인으로
              router.push({ name: "main", params: { siteCode: this.state.siteCode, lang: this.state.lang } });
            } else if (route.matched.length >= 3) {
              if (route.meta.isLast === true) {
                if (route.name == "napasQrPaymentStep3" || route.name == "mmQrPaymentStep4") {
                  router.push({ name: "main", params: { siteCode: this.state.siteCode, lang: this.state.lang } });
                } else {
                  router.push({ path: route.matched[1].path });
                }
              } else if (route.meta.step == "1" || route.meta.step == undefined) {
                router.push({ name: "main", params: { siteCode: this.state.siteCode, lang: this.state.lang } });
              } else if (route.meta.step == "2") {
                const goFirstStep = this.state.history[this.state.history.length - 1];
                this.state.history = [];
                router.push({ name: goFirstStep.name });
              } else {
                const goBack = this.state.history[this.state.history.length - 1];
                if (goBack !== undefined) {
                  this.state.history.pop();
                  if (_.isEmpty(goBack.params)) {
                    //당행이체 완료 -> 자주쓰는계좌등록 -> 뒤로가기 -> 자주쓰는계좌목록이 나오도록 예외처리
                    if (route.name == "managePayeesRegister" && goBack.name == "trsaccInfoInptStep4") {
                      router.push({ name: "managePayeesList" });
                    } else {
                      router.push({ name: goBack.name });
                    }
                  } else {
                    router.push({ name: goBack.name, params: goBack.params });
                  }
                } else {
                  router.push({ name: "main", params: { siteCode: this.state.siteCode, lang: this.state.lang } });
                }
              }
            } else {
              router.go(-1);
            }
          }
        }
      }
    },
  },
  actions: {
    actGoBackPage: function (context) {
      context.commit("goBackPage");
    },
    /**
     * getNativeData 를 동기로 가져온다.
     * @param {*} context
     * @param {*} payload
     */
    actGetNativeData: function (context, payload) {
      this.state.native.checkGetSetNative === false;
      this._vm.$bridge.getNativeData([payload]);
      return new Promise(resolve => {
        checkingNative = setInterval(() => {
          if (this.state.native.checkGetSetNative === true) {
            clearInterval(checkingNative);
            resolve(this.state.native[payload]);
          }
        }, 5);
      });
    },
    /**
     * native push 수신 후 callback
     */
    pushCallback: function (context, payload) {
      // this._vm.$log.info("pushCallback >>>> " + JSON.stringify(payload));
      // switch (payload.biz) {
      //   case "R002": // authPCMotp 업무
      //     this.dispatch("auth/authPCMotp/act009", payload);
      //     break;
      // }
      this._vm.$log.info("pushCallback >>>> " + JSON.stringify(payload));
      if (payload.bzwkDstcd === "8010" && payload.notiDstcd === "R002") {
        // authPCMotp 업무
        //alert("0" + JSON.stringify(payload));
        this.dispatch("auth/authPCMotp/act009", payload);
      } else if (payload.bzwkDstcd == "3020" && (payload.notiDstcd == "2001" || payload.notiDstcd == "2002")) {
        //alert("1" + JSON.stringify(payload));
        router.push({ name: payload.bizParam.router });
      } else if (payload.bzwkDstcd == "8010" && payload.notiDstcd == "R003") {
        //alert("2" + JSON.stringify(payload));
        router.push({ name: payload.bizParam.router });
      } else if (payload.bzwkDstcd == "8010" && payload.notiDstcd == "R004") {
        // 생체정보검증알림 : brncoBzwkDstcd="8010", pushNotizDstcd="R004"
        this.dispatch("auth/authPCMotp/act010", payload);
      }
      // 푸시 테스트
      /*
      else {
        router.push({ name: payload.bizParam.router });
      }
      */
    },
    /**
     * local / dev 이외 환경인 경우
     * 정상적인 native 이용상태가 아닌경우 appDown Url 이동.
     */
    actGoAppDown: function () {
      if ("local|development".includes(process.env.NODE_ENV)) {
        this.state.error.errCode = "actGoAppDown";
        if (this._vm.$bridge.isAndroid()) {
          this.state.error.errMsg = "play store 이동";
        } else {
          this.state.error.errMsg = "app store 이동";
        }
        this.state.error.active = true;
      } else {
        if (this._vm.$bridge.isAndroid()) {
          location.replace("https://play.google.com/store/apps/details?id=com.kbstar.global");
        } else {
          location.replace("https://apps.apple.com/kr/app/kb-global-banking/id1542727700");
        }
      }
    },
    // 퍼미션 있는지 물어보고 여기서 payload
    checkPermission(context, payload) {
      // true 일 때 퍼미션이 있는거니까 바로 qr scan
      // let permissions = ["1", "2"]; // 1 = camera, 2 = photo
      if (this.state.native.isAllowPermissions === true) {
        console.log(
          "qr scan 버튼 클릭 -> 네이티브콜 -> dispatch를 통해 native/index.js 로 이동 -> checkPermissions 함수 돌면서 퍼미션 있나 확인 -> 있으면 바로 qrScanForTransfer 진행 ",
        );
        this._vm.$bridge.qrScanForTransfer(this.state.common.main.operGroupCd); // TEST VN1 -
        if(this.state.common.main.operGroupCd.includes("MM"))
        {
          router.push({ name: "main", params: { siteCode: this.siteCode, lang: this.lang } });
        }
      } else {
        console.log("qr scan 버튼 클릭 -> 네이티브콜 -> dispatch를 통해 native/index.js 로 이동 -> checkPermissions 함수 돌면서 퍼미션 있나 확인 -> 없으면 퍼미션 제공 진행");
        console.log(payload);
        context.state.permissionChk = payload;
      }
    },

    grantPermission(context, payload) {
      context.state.permissionChk = payload.data; // 권한을 부여했으니 store 내 state 값 변경
      console.log("grantPermission payload: " + JSON.stringify(payload));
      if (this.state.native.isGrantPermissions === false) {
        if (payload.isPopup == "1") {
          context.state.permissionChk = "";
        }
        console.log("Permission denied");
      } else {
        this._vm.$bridge.qrScanForTransfer(this.state.common.main.operGroupCd);
      }
      // 네이티브에서 권한 주는 과정에서 시간차가 존재하여 한 번에 QR Scan으로 넘어가지 않는 문제가 발생하므로
      // 권한 주면서 QR Scan을 받도록 진행
    },

    moveToMain(context, payload) {
      console.log(context + "," + payload);
      router.push({ name: "main" });
    },
    // eKYC TEST
    eKycProcess(context, payload) {
      console.log("haams : " + JSON.stringify(payload));
      if (this.state.native.depositEkyc === true) {
        router.push({ name: "depositNewReqCreateEkycConfirm", params: { eKycParam: payload } });
      } else {
        let type = payload["type"];
        // 내국인
        if (type == "0" && !_.isEmpty(payload)) {
          router.push({ name: "createEkycConfirm", params: { eKycParam: payload } });
        }
        // 외국인
        else if (type == "1" && !_.isEmpty(payload)) {
          router.push({ name: "createForgnEkycConfirm", params: { eKycParam: payload } });
        } else {
          console.log("타입 오류(내국인/외국인도 아님)");
        }
      }
    },
  },
};

/**
 * main 컴포넌트 찾기
 * @param {Array} children children 리스트
 */
const findSearchBox = children => {
  for (const comp of children) {
    if (comp.$vnode.tag !== undefined && comp.$vnode.tag.indexOf("-rootMain") > 0) {
      return comp;
    } else {
      let etc = findSearchBox(comp.$children);
      if (etc !== undefined) return etc;
    }
  }
};

export default native;
